import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { makeStyles } from '@material-ui/core';
import { toast } from 'react-toastify';
import { dataService } from "../../Services/data.service";
import { TextField } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

export default function TypeOfContract(props) {

  const [purchaseOrderTypes, setPurchaseOrderTypes] = useState([])
  const [purchaseOrderType, setPurchaseOrderType] = useState(null)
  const classes = useStyles();

  useEffect(() => {
    dataService.getPurchaseOrderTypes().then(types => {

      if (JSON.stringify(purchaseOrderTypes) !== JSON.stringify(types.Results.sort((a, b) => new Date(b.Name) - new Date(a.Name)))) {
        setPurchaseOrderTypes(types.Results.sort((a, b) => new Date(b.Name) - new Date(a.Name)))
      }

      if (props.chosenValue){
        if(JSON.stringify(purchaseOrderType) !== JSON.stringify(types.Results.find(x => x.Name === props.chosenValue))){
          console.log(types.Results.find(x => x.Name === props.chosenValue))
          setPurchaseOrderType(types.Results.find(x => x.Name === props.chosenValue))
        }
      } 
    }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
  }, [])

  const setNextStep = () => {
    validate();
  }

  const validate = () => {
    if (purchaseOrderType) {
      props.SetNext();
      props.setContent(purchaseOrderType.ID, purchaseOrderType.Name);
      props.setDataArea(purchaseOrderType.DataArea);
    } else {
      toast.error("Pick a contract type", { position: toast.POSITION.TOP_CENTER })
    }
  }

  const onChangeItem = (e) => {
    setPurchaseOrderType(purchaseOrderTypes.find(x => x.ID === e.target.value))
  }

  const onChangeFilterTextPress = (e) => {
    let tempList = [...purchaseOrderTypes]
    tempList = tempList.filter(x => x.Name.includes(e.target.value))
    setPurchaseOrderTypes(tempList)
  }  

  return (
    <div className={classes.purchaseOrderTypeContainer}>
      {purchaseOrderTypes.length > 0? <React.Fragment>
        {purchaseOrderTypes.length > 15 ?
          <div className={classes.container}>
            <div className={classes.filterField}>
              <TextField id="outlined-search" label="" type="search" variant="outlined" className={classes.uiTextField} size="small" onChange={(e) => onChangeFilterTextPress(e)} />
            </div>
          </div> : <div></div>}         
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select2"
          className={classes.typeOfContractPicker}
          value={purchaseOrderType && purchaseOrderType.ID}
          onChange={(e) => onChangeItem(e)}
        >
          {purchaseOrderTypes.map(x => {
            return (
              <MenuItem value={x.ID}>{x.Name}</MenuItem>)
          })}

        </Select>
        <NextPrevButtons hasPrevious={props.hasPrevious} hasNext={props.hasNext} SetPrevious={props.SetPrevious} SetNext={setNextStep}></NextPrevButtons>
      </React.Fragment> :
        <React.Fragment></React.Fragment>}
    </div>
  )
}


const useStyles = makeStyles({
  container: {
    flexDirection: "row"
  },
  filterField: {
    width: "80%",
    flex: 1,
    justifyContent: 'center'
  },
  buttonContainer: {
    width: "15%",
    flex: 1,
    justifyContent: 'center'
  },
  typeOfContractPicker: {
    height: 44,
    backgroundColor: 'white',
    borderWidth: 1,
    marginBottom: 10,
    width:"100%"
  },
  purchaseOrderTypeContainer: {
    marginTop: "30px"
  },
  uiTextField: {
    width: "95%",
    backgroundColor: "white"
  },
});